import { includes, isArray } from 'lodash';

export const PERMISSION_KEYS = {
  ADMIN_DASHBOARD: 'admin_dashboard',
  ENGINEERING_SUPPORT: 'engineering_support',
  MIGRATIONS: 'migrations',
  MANAGE_PERMISSIONS: 'manage_permissions',
};

export const hasAdminDashboardPermission = (user, key) => (
  Boolean(user && isArray(user.admin_permissions) && includes(user.admin_permissions, key))
);

export const canManageAdminDashboardPermissions = (user) => (
  hasAdminDashboardPermission(user, PERMISSION_KEYS.MANAGE_PERMISSIONS)
);

export const canSeeMigrationsTab = (user) => (
  hasAdminDashboardPermission(user, PERMISSION_KEYS.MIGRATIONS)
);
